export default __webpack_public_path__ + "static/media/fedex-logo.9d52e55f.svg";